import SVG_ENUM from "./SvgEnum";

/**
 *
 * | slug              | name                 |
 * |-------------------|----------------------|
 * | stocks            | Akcje                |
 * | shares            | Udziały              |
 * | real_estate       | Nieruchomość         |
 * | crypto            | Krypto               |
 * | precious_stones   | Kamienie szlachetne  |
 * | precious_metals   | Metale szlachetne    |
 * | treasury_bonds    | Obligacje skarbowe   |
 * | artwork           | Dzieło sztuki        |
 * | investment_policy | Polisa inwestycyjna  |
 * | loans             | Pożyczki             |
 * | currencies        | Obce waluty          |
 */

export const ASSET_CATEGORY_SLUG = {
  STOCKS: "stocks",
  SHARES: "shares",
  REAL_ESTATE: "real_estate",
  CRYPTO: "crypto",
  PRECIOUS_STONES: "precious_stones",
  PRECIOUS_METALS: "precious_metals",
  TREASURY_BONDS: "treasury_bonds",
  ARTWORK: "artwork",
  INVESTMENT_POLICY: "investment_policy",
  LOANS: "loans",
  CURRENCIES: "currencies",
} as const;

export type AssetCategorySlug =
  (typeof ASSET_CATEGORY_SLUG)[keyof typeof ASSET_CATEGORY_SLUG];

export const ASSET_CATEGORY_SVG_MAP: Record<AssetCategorySlug, SVG_ENUM> = {
  [ASSET_CATEGORY_SLUG.STOCKS]: SVG_ENUM.STOCKS,
  [ASSET_CATEGORY_SLUG.SHARES]: SVG_ENUM.SHARES,
  [ASSET_CATEGORY_SLUG.REAL_ESTATE]: SVG_ENUM.REAL_ESTATE,
  [ASSET_CATEGORY_SLUG.CRYPTO]: SVG_ENUM.CRYPTO,
  [ASSET_CATEGORY_SLUG.PRECIOUS_STONES]: SVG_ENUM.PRECIOUS_STONES,
  [ASSET_CATEGORY_SLUG.PRECIOUS_METALS]: SVG_ENUM.PRECIOUS_METALS,
  [ASSET_CATEGORY_SLUG.TREASURY_BONDS]: SVG_ENUM.TREASURY_BONDS,
  [ASSET_CATEGORY_SLUG.ARTWORK]: SVG_ENUM.ARTWORK,
  [ASSET_CATEGORY_SLUG.INVESTMENT_POLICY]: SVG_ENUM.INVESTMENT_POLICY,
  [ASSET_CATEGORY_SLUG.LOANS]: SVG_ENUM.LOANS,
  [ASSET_CATEGORY_SLUG.CURRENCIES]: SVG_ENUM.CURRENCIES,
};


export const getAssetCategorySvg = (slug: string): SVG_ENUM => {
  return ASSET_CATEGORY_SVG_MAP[slug as AssetCategorySlug] ?? SVG_ENUM.OTHER_ASSET;
};


export const ASSET_CATEGORY_NAMES: Record<AssetCategorySlug, string> = {
  [ASSET_CATEGORY_SLUG.STOCKS]: "Akcje",
  [ASSET_CATEGORY_SLUG.SHARES]: "Udziały",
  [ASSET_CATEGORY_SLUG.REAL_ESTATE]: "Nieruchomości",
  [ASSET_CATEGORY_SLUG.CRYPTO]: "Tokeny / kryptowaluty",
  [ASSET_CATEGORY_SLUG.PRECIOUS_STONES]: "Kamienie szlachetne",
  [ASSET_CATEGORY_SLUG.PRECIOUS_METALS]: "Metale szlachetne",
  [ASSET_CATEGORY_SLUG.TREASURY_BONDS]: "Obligacje skarbowe",
  [ASSET_CATEGORY_SLUG.ARTWORK]: "Dzieło sztuki",
  [ASSET_CATEGORY_SLUG.INVESTMENT_POLICY]: "Polisa inwestycyjna",
  [ASSET_CATEGORY_SLUG.LOANS]: "Pożyczki",
  [ASSET_CATEGORY_SLUG.CURRENCIES]: "Obce waluty",
};
